import React from "react"
import WebriqForm from "@webriq/gatsby-webriq-form"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { StaticImage } from "gatsby-plugin-image"
import InstagramFeed from "react-ig-feed"
import { Link } from "gatsby"
import "react-ig-feed/dist/index.css"

import ok from "@images/ok-sign.png"

const footer = props => {
  return (
    <footer>
      <div className="contact-footer" id="contact">
        <div className="main-box">
          <div className="bg-box" />
          <div className="content-box">
            <div className="row">
              <div className="col-lg-5 col-md-6">
                <div className="form-content">
                  {" "}
                  <h2 className="title font-weight-bold mb-4">
                    Rally the Revolutionaries
                  </h2>
                  <p className="mb-0">
                    We normalized a world where every label or measurement
                    possible from politics to science to theology is used to
                    brand us, isolate us, and further divide us from ourselves,
                    each other, and our environment. As our sense of Self
                    developed, we started to feel separate from Everything. The
                    awareness of our humanity began to fade, my friends. Many
                    more than ever questioned the meaning of our lives in this
                    losing game of resistance.
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 text-center">
                <img className="img-fluid" src={ok} />
              </div>
              <div className="col-lg-5 col-md-12">
                {" "}
                <div className="form-box">
                  <h3 className="font-weight-bold">Join the Revolution</h3>
                  <LazyLoadComponent>
                    <WebriqForm
                      webriqform="true"
                      name="Join the Revolution"
                      id="revolution"
                      className="revolution-form"
                      data-form-id="67049862-7561-431f-bb20-7a3064928565"
                      data-thankyou-url="/thank-you"
                    >
                      <div className="form-group d-flex my-4">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your email address"
                          name="Email address"
                          required
                        />
                        <div className="webriq-recaptcha" />
                        <button className="footer-button" type="submit">
                          Submit
                        </button>
                      </div>
                    </WebriqForm>
                  </LazyLoadComponent>
                  <small>
                    By clicking the submit button you subscribe to our
                    newsletter and acknowledge you have read and understood the
                    Privacy Notice and consent to the processing of your
                    personal data for marketing purposes.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-links">
          <div className="container">
            <div className="row">
              {/* <div className="col-lg-5">
                <div className="instagram-feed">
                  <InstagramFeed token="your_access_token" counter="6" />{" "}
                </div>
              </div> */}
              <div className="col-lg-12 mx-auto">
                <div className="row">
                  {/* <div className="col-lg-1 mb-5">
                    {" "}
                    <ul className="list-style-none pl-0">
                      <li>
                        <a href="#">Our Story</a>
                      </li>
                      <li>
                        <a href="#">Made in the U.S.A.</a>
                      </li>
                    </ul>
                  </div> */}
                  <div className="col-md-3 mb-4 d-flex justify-content-center">
                    <ul className="list-style-none pl-0">
                      <li>
                        <a href="/">
                          <StaticImage
                            className="mb-4"
                            src="../../images/coloradoCompanyLogo.png"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3 mb-4 d-flex justify-content-center">
                    <ul className="list-style-none pl-0">
                      <li>
                        <Link to="/support-center/">Support Center</Link>
                      </li>
                      <li>
                        <a href="/support-center/">Contact Us</a>
                      </li>
                      <li>
                        <Link to="/support-center/">Order Status</Link>
                      </li>
                      <li>
                        <Link to="/support-center/">
                          Shipping & Information
                        </Link>
                      </li>
                      <li>
                        <Link to="/support-center/">
                          Returns &amp; Exchanges
                        </Link>
                      </li>
                      <li>
                        <a href="#">Press & Media</a>
                      </li>
                      <li>
                        <Link to="/support-center/">Gift Cards</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3 mb-4 d-flex justify-content-center">
                    <ul className="list-style-none pl-0">
                      <li>
                        <Link to="/stories/">Our Story</Link>
                      </li>
                      <li>
                        <a href="/rally/">Our Rally</a>
                      </li>
                      <li>
                        <Link to="/belief/">Our Beliefs</Link>
                      </li>
                      <li>
                        <Link to="/why-fluo/">Our Youth</Link>
                      </li>
                      <li>
                        <Link to="/stewardship/">Our Ways</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3 mb-4 d-flex justify-content-center">
                    {" "}
                    <div>
                      <StaticImage
                        className="mb-3"
                        src="../../images/footer-logo.png"
                      />
                      <div className="socials">
                        <a
                          href="https://www.instagram.com/FLUOFeelAlive/"
                          target="_blank"
                          className="my-2"
                        >
                          <StaticImage
                            width={36}
                            height={36}
                            layout="fixed"
                            src="../../images/social-logos/insta.png"
                          />
                        </a>
                        <a
                          href="https://www.facebook.com/FLUOFeelAlive/"
                          target="_blank"
                          className="my-2"
                        >
                          <StaticImage
                            width={36}
                            height={36}
                            layout="fixed"
                            src="../../images/social-logos/fb.png"
                          />
                        </a>
                        <a
                          href="https://www.youtube.com/channel/UCbXUCc-pw5mIo5dNoTB0qoQ"
                          target="_blank"
                          className="my-2"
                        >
                          <StaticImage
                            width={36}
                            height={36}
                            layout="fixed"
                            src="../../images/social-logos/yt.png"
                          />
                        </a>
                        <a
                          href="https://www.linkedin.com/company/fluofeelalive/"
                          target="_blank"
                          className="my-2"
                        >
                          <StaticImage
                            width={36}
                            height={36}
                            layout="fixed"
                            src="../../images/social-logos/ln.png"
                          />
                        </a>
                        <a
                          href="https://www.pinterest.ph/FLUOFeelAlive/_created/"
                          target="_blank"
                          className="my-2"
                        >
                          <StaticImage
                            width={36}
                            height={36}
                            layout="fixed"
                            src="../../images/social-logos/pt.png"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="faq d-flex align-items-center">
                  <span>
                    <Link href="/privacy-policy">Privacy Policy</Link> |{" "}
                    <a href="#">Terms of Usage</a> |{" "}
                    <a href="#">California Notice of Collection</a>
                  </span>
                </div>
                <div className="copyright-section mt-2">
                  <h6 className="text-white mb-0">
                    Copyright © {new Date().getFullYear()} FLUO, LLC. All Rights
                    Reserved.
                  </h6>
                </div>
              </div>
              <div className="col-lg-6 footer-logo-farm">
                <div className="d-flex flex-wrap">
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/1.png"
                    />
                  </div>
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/2.png"
                    />
                  </div>
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/3.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/4.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/5.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/6.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/7.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/8.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/9.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/10.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/11.png"
                    />
                  </div>{" "}
                  <div className="mr-1 mt-1">
                    <StaticImage
                      width={50}
                      height={30}
                      layout="fixed"
                      src="../../images/footer-logo/12.png"
                    />
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default footer
